import { render, staticRenderFns } from "./prodductClientComponent.vue?vue&type=template&id=5321c658&scoped=true&"
import script from "./prodductClientComponent.vue?vue&type=script&lang=js&"
export * from "./prodductClientComponent.vue?vue&type=script&lang=js&"
import style0 from "./prodductClientComponent.vue?vue&type=style&index=0&id=5321c658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321c658",
  null
  
)

export default component.exports